import { noop } from 'lodash'
import React from 'react'
import { Index, IndexRange, InfiniteLoader } from 'react-virtualized'

interface InfinityLoaderProps {
  children: React.FC<any>
  displayOnly: boolean
  setRef: React.LegacyRef<InfiniteLoader>
  threshold: number
  isRowLoaded: (params: Index) => boolean
  loadMoreRows: (params: IndexRange) => Promise<any>
  rowCount: number
  minimumBatchSize: number
}

const InfinityLoader = (props: InfinityLoaderProps): React.ReactElement => {
  const {
    children,
    displayOnly,
    setRef,
    threshold,
    isRowLoaded,
    loadMoreRows,
    rowCount,
    minimumBatchSize,
    ...rest
  } = props

  if (displayOnly) {
    return children({
      onRowsRendered: noop,
      registerChild: noop,
    }) as React.ReactElement
  }

  return (
    <InfiniteLoader
      isRowLoaded={isRowLoaded}
      loadMoreRows={loadMoreRows}
      rowCount={rowCount}
      minimumBatchSize={minimumBatchSize}
      {...rest}
      threshold={threshold}
      ref={setRef}
    >
      {({ onRowsRendered, registerChild }) => {
        return children({ onRowsRendered, registerChild })
      }}
    </InfiniteLoader>
  )
}

export default InfinityLoader
